<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Eigenschaft erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.properties.store'))">
                <form-fields :form="form" :property-type-options="propertyTypeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'propertyTypeOptions',
            'sortingTypeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    slug: null,
                    property_type: null,
                    sorting_type: null,
                    description: null,
                    filterable: true,
                    visible_on_product_page: true,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>